import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTadoComponent } from './simple-icons-tado.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTadoComponent ],
    exports:      [ SimpleIconsTadoComponent ],
    bootstrap:    []
})
export class SimpleIconsTadoModule {}
